import { api } from "technical/api";

export async function getTenants(authId: string) {
  const tenants = await api("")
    .get<string[]>(`/v1/tenants/users/${authId}`)
    .then((response) => response.data);

  return tenants;
}
